// Copyright (c) StrangeBee 2023

import { AdminPermissions, OrgPermissions, CaseOutput } from 'thehive-sdk';
import usePermissions from '@Hooks/usePermissions';
import client from '@Client';
import useOneQuery from './useOneQuery';
import { computeGetSelector } from '@Organisms/Case/selector';

interface UseCasePermissionsInterface {
    caseId: string;
    permissionsNeeded: AdminPermissions[] | OrgPermissions[];
}

const useCasePermissions = ({ caseId, permissionsNeeded }: UseCasePermissionsInterface): boolean => {
    const { data: caseData } = useOneQuery<CaseOutput>({
        selector: computeGetSelector({ caseId }),
        controller: client.CaseController,
        manual: true,
        fetchOnStart: false,
    });

    // The case permissions are in the extraData prop from the case
    const { extraData } = caseData || {};
    const { permissions = [] } = extraData || {};

    const hasPermissions = usePermissions({
        permissionsNeeded,
        permissionsList: permissions,
    });

    return hasPermissions;
};

export default useCasePermissions;
